export default {
  getCustomerSettlements: state => state.customerSettlements,
}
